import styled from "styled-components";
import { Input, Space, Col as AntCol, Image as AntImage } from "antd";
import { DefaultIMG } from '@assets';

export const RootContainer = styled.div`
position: relative;

.ant-row {
  padding: 0 10px;

  @media screen and (max-width: 426px) {
    padding: 0;
          margin-left: -6px !important;
          margin-right: -6px !important;
    }

  @media screen and (max-width: 376px) {
          margin-left: -5px !important;
          margin-right: -5px !important;
    }

  @media screen and (max-width: 330px) {
          margin-left: -4px !important;
          margin-right: -4px !important;
    }
  }
`;

export const Container = styled.div`
padding: 16px;
`;

export const Divider = styled.div`
width: 100%;
height: 1px;
background-color: #242424;
`;

export const TabsWrapper = styled(Space)`
  margin-top: 16px;
  padding: 0 16px;
  width: calc(100% - 32px);
  overflow: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const Tab = styled.div`
padding: 5px 16px;
border-radius: 38px;
background: ${props => props.status === 'active' ? '#E89E0C' : '#242424'};

font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: normal;
color: ${props => props.status === 'active' ? '#0B0A0A' : '#fff'};;
overflow: hidden;
white-space: nowrap;
cursor: pointer;
`;

export const SearchInput = styled(Input)`
margin-bottom: 16px;
height: 40px;
padding: 8px 12px;
border-radius: 12px;
border: 1px solid #1E1A1B;
background: #1E1A1B;

input {
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    background-color: #1E1A1B !important;

    ::placeholder {
      color: #949393;
      font-weight: 600 !important;
      font-size: 16px !important;
    }
}

.anticon {
    color: #DEDEDE;
    font-size: 24px;
    margin-right: 8px;
}

.ant-input-clear-icon {
  display: flex;
}

:hover, :focus {
    border-color: #1E1A1B !important;
    box-shadow: none !important;
}
`;

export const Col = styled(AntCol)`
width: 25%;
text-align: center;

@media screen and (max-width: 426px) {
				padding-left: 12px !important;
				padding-right: 12px !important;
	}

@media screen and (max-width: 376px) {
				padding-left: 10px !important;
				padding-right: 10px !important;
	}

@media screen and (max-width: 330px) {
				padding-left: 8px !important;
				padding-right: 8px !important;
	}
`;

export const Image = styled(AntImage).attrs({
  alt: "gameicon",
  fallback: DefaultIMG,
  preview: false,
})`
    width: 100%;
    border-radius: 12px;
    object-fit: cover;
    aspect-ratio: 1;
    cursor: pointer;
`;

export const Text = styled.div`
  width: 100%;
  padding-top: 5px;
  display: inline-block;

  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #fff;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: 376px) {
		font-size: 10px;
	}
`;

export const SpinWrapper = styled.div`
height: calc(100vh - 145px);
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`;

export const EmptyBox = styled.div`
	width: 100%;
	/* height: calc(100vh - 500px); */
  margin-top: 30%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const NoResultText = styled.div`
	padding-top: 32px;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	color: #949393;
`;